import type { ScheduleForecastState } from "../../domain/weather";
import { Card, CardContent } from "../../shared/ui/card";
import { GameWeather } from "../schedule/GameWeather";

interface SetupWeatherCardProps {
  state: ScheduleForecastState | undefined;
  onRetry: () => void;
  refreshing?: boolean;
}

export function SetupWeatherCard({
  state,
  onRetry,
  refreshing = false,
}: SetupWeatherCardProps) {
  if (!state) return null;

  return (
    <Card className="shadow-none">
      <CardContent className="grid gap-2 pt-4">
        <div className="flex items-center justify-between gap-3">
          <h3 className="m-0 font-mono text-sm font-bold tracking-[0.08em] text-warning uppercase">
            Game weather
          </h3>
          <span className="text-[0.68rem] text-foreground-muted">
            Data by{" "}
            <a
              className="font-bold text-primary underline underline-offset-2"
              href="https://open-meteo.com/"
            >
              Open-Meteo
            </a>
          </span>
        </div>
        <GameWeather state={state} onRetry={onRetry} refreshing={refreshing} />
      </CardContent>
    </Card>
  );
}
